import styled from "@emotion/styled";
import theme from "../../styles/theme";
import CTA from "../cta/cta";

export const FullWidthCTABase = styled.div`
  position: relative;
  background-color: ${theme.colors.blues[10]};
  overflow: hidden;

  &.xom-blue {
    background-color: ${theme.colors.blues[100]};
    color: ${theme.colors.white};

    .container {
      position: relative;
      z-index: 10;
    }

    .grid {
      align-items: center;
    }

    h2 {
      color: ${theme.colors.white};
    }

    a {
      color: ${theme.colors.white};
    }
  }
`;

export const Image = styled.img`
  aspect-ratio: 1 / 1;
  width: 100%;
`;

export const Description = styled.div`
  font-size: ${theme.fontSizes[2]};
`;

export const CTAStyled = styled(CTA)`
  padding: ${theme.spacing[4]} ${theme.spacing[8]};
  margin-bottom: ${theme.spacing[4]};
`;

export const FinePrint = styled.div`
  font-size: ${theme.fontSizes[2]};
  margin-bottom: ${theme.spacing[8]};

  & a {
    text-decoration: underline;
  }
`;

export const BackgroundImage = styled.div`
  position: absolute;
  right: ${theme.spacing[8]};
  bottom: -${theme.spacing[16]};
  opacity: 0.5;

  ${theme.smallerThan.md} {
    width: 200px;
    height: auto;
    right: -${theme.spacing[2]};
    bottom: -${theme.spacing[8]};
  }
`;
